import _ from "lodash";
import { hdlChg, hdlIsVal, RenderInput } from "./PreviewForm";
import { useEffect, useState } from "react";
import { returnFormData, returnIsValid } from "./formStarter";

export const CatalogueTypeOther = ({
  entireSchema, entirePathSchema, setSchemaState,
  entireFormData, entirePathData, setFormData,
  entireIsValid, setIsValid,
  constraints, setConstraints,
  attachments, setAttachments,
  tryToNext, activeStep,
  parentValue,
  parentOrigin,
}) => {

  const [rerendering, setRerendering] = useState(false);

  const parentSchema = _.get(entireSchema, entirePathSchema);
  const endsWithOther = parentValue?.endsWith("type::other");

  const typeOtherInputs = parentSchema?.typeOther || [];

  useEffect(() => {
    if (rerendering) {
      setRerendering(false);
    }
  }, [rerendering]);

  useEffect(() => {
    changeSchema();
  }, [parentValue]);

  function changeSchema() {
    if (!rerendering && typeOtherInputs.length > 0 ) {
      if (endsWithOther) {
        let newDataTypeOther = Array.isArray(typeOtherInputs) && returnFormData(typeOtherInputs, `${parentOrigin}::typeOther`) || [];
        let newValidTypeOther = Array.isArray(typeOtherInputs) && returnIsValid(typeOtherInputs) || [];
        hdlChg({e:{target:{ value: newDataTypeOther }}, params: { typeOther: newDataTypeOther }, entireFormData, entirePathData, setFormData});
        hdlIsVal({errors: newValidTypeOther, entirePathDataWithKey: `${entirePathData}.typeOther`, entireIsValid, setIsValid});
      } else {
        hdlChg({e:{target:{ value: [] }}, params: { typeOther: [] }, entireFormData, entirePathData, setFormData});
        hdlIsVal({errors: [], entirePathDataWithKey: `${entirePathData}.typeOther`, entireIsValid, setIsValid});
      }
    }
  }

  if (typeOtherInputs.length === 0 || !endsWithOther) return null;

  return (
    <>
    {
      typeOtherInputs.map((sch,idx) => (
        <RenderInput
          key={`${parentOrigin}::typeOther::${idx}`}
          entireSchema={entireSchema}
          entirePathSchema={`${entirePathSchema}.typeOther.${idx}`}
          setSchemaState={setSchemaState}
          entireFormData={entireFormData}
          entirePathData={`${entirePathData}.typeOther.${idx}`}
          setFormData={setFormData}
          entireIsValid={entireIsValid}
          setIsValid={setIsValid}
          constraints={constraints}
          setConstraints={setConstraints}
          attachments={attachments}
          setAttachments={setAttachments}
          tryToNext={tryToNext}
          activeStep={activeStep}
          origin={`${parentOrigin}::typeOther::${idx}`}
        />
      ))
    }
    </>
  )
}
